module.exports = __webpack_public_path__ + "static/img/13areaA_4.600f727.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_4.png
// module id = 1003
// module chunks = 1